export default __webpack_public_path__ + "static/media/mimi-thian-vdXMSiX-n6M-unsplash.d46d17e3.png";